"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GatewayService = _interopRequireDefault(require("../GatewayService.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var thirdPartySecrets = new _GatewayService["default"]('third-party-secrets');

var fetchIntercomUserHash = function fetchIntercomUserHash() {
  return thirdPartySecrets.get('intercom/keycloakUserHash');
};

var fetchLearnositySignature = function fetchLearnositySignature() {
  return thirdPartySecrets.get('learnosity/config');
};

var fetchQuillHash = function fetchQuillHash() {
  return thirdPartySecrets.get('quill/userHash');
};

var _default = {
  fetchIntercomUserHash: fetchIntercomUserHash,
  fetchLearnositySignature: fetchLearnositySignature,
  fetchQuillHash: fetchQuillHash
};
exports["default"] = _default;